import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveTool } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveToolActivity = ({ values }: IProjectActivity<IProjectActivityRemoveTool>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveTool')}
      <b>{values.name}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
